/* pageTop
========================================================= */
export function pageTop($) {
  const $window = $(window);
  const $pageTop = $('#pagetop');

  if (!$pageTop.length) {
    return;
  }

  $pageTop.hide();

  function updatePageTop() {
    const isVisible = $window.scrollTop() > 100;

    $pageTop.stop(true, true)[isVisible ? 'fadeIn' : 'fadeOut']();
  }

  $window.on('scroll.pageTop', updatePageTop);

  updatePageTop();
}
